import BufferQueue from './BufferQueue'

export default ({
  BufferQueue
}) 
